// extracted by mini-css-extract-plugin
module.exports = {"section":"CES2026_section__Xe55P"};